define([
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/locale",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginToggleButton"
], function(lang, _, locale, PluginFactory, ToolbarPluginToggleButton) {

	return PluginFactory.declare("tableSuspend", ToolbarPluginToggleButton, {
		constructor: function() {
			this.defAction.m_id = "TableSuspend";
			this.defAction.resolve();
		},

		/**
		 * hide plugin but keep this plugin code working
		 * TODO: move useful code to batchFilter plugin
		 * @returns {boolean}
		 */
		canShowPlugin: function() {
			return false;
		},

		enablePlugin: function(/*Context?*/ctx) {
			var view = this.getView();
			var hasFilter = !_.isEmpty(view.query);
			var disabledFlag = view.get("suspended") && view.get("suspendedRequireFilter") && !hasFilter;
			var title = disabledFlag ? locale.resource("TableSuspend_NotAllowed") : (locale.tooltip(this.defAction.m_id) || "");
			this.set("title", title);
			this._setDisabled(this, disabledFlag);
		},

		postCreate: function() {
			// summary: toggle button to true if that is default for view
			var view = this.getView();
			this.inherited(arguments);
			view.set("suspendIsOption", true);
			view.watch("suspended", lang.hitch(this, this._onWatchSuspended));
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: do not render plugin if querying not allowed or if query size is fixed to display all
			return !ctx.bPrint && ctx.view.bSupportsQuerySettings && (ctx.view.get("querySize") || !ctx.view.get("querySizeFixed"));
		},

		_onWatchSuspended: function(/*String*/name, /*Any*/oldValue, /*Any*/newValue) {
			// summary: set disabled false to make sure onChange invokeAction is called while changing views
			const suspended = !!newValue;

			this.set("checked", suspended, false);
			this.set("disabled", false, false);

			this.actionToolbar.setModalPlugin(null);
		}
	});
});